import { REHYDRATE } from "redux-persist";

const initialState = {
  demo: false,
  link: "interactive",
};

const demoReducer = (state = initialState, action) => {
  switch (action.type) {
    case "TOGGLE_DEMO":
      return {
        ...state,
        demo: action.payload,
      };

    case "SET_DEMO":
      // Spread the entire state so both `demo` and `link` are preserved.
      return {
        ...state,
        demo: action.payload,
      };

    case "SET_DEMO_OBJ":
      // If you expect `demo` to be an object, merge the current object with the payload.
      return {
        ...state,
        demo: {
          ...state.demo,
          ...action.payload,
        },
      };

    case REHYDRATE:
      // Merge persisted data with initial state if available.
      if (action.payload && action.payload.demoReducer) {
        return {
          ...state,
          ...action.payload.demoReducer,
        };
      }
      return state;

    default:
      return state;
  }
};

export default demoReducer;
